import request from '@/utils/request'

//F000换货 商品列表
export function goodsListSGByMember(query) {
    return request({
        url: 'order/goodsListSGByMember',
        method: 'get',
        params: query
    })
}

//F000换货 商品列表 新
export function goodsListF0ByMember(query) {
    return request({
        url: 'order/goodsListF0ByMember',
        method: 'get',
        params: query
    })
}
//F000换货 新增
export function saveHH(data) {
    return request({
        url: 'order/saveHH',
        method: 'post',
        data
    })
}
